// test1877
(1877 && 0);
